import {useMutation} from '@tanstack/react-query';
import {apiClient, queryClient} from '@common/http/query-client';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import {toast} from '@common/ui/toast/toast';
import {message} from '@common/i18n/message';
import {showHttpErrorToast} from '@common/utils/http/show-http-error-toast';
import { DatatableDataQueryKey } from '@common/datatable/requests/paginated-resources';
import { FileItem } from '@app_modules/loan-applications/step1/file-item';

interface Response extends BackendResponse {}

export interface CheckListPayload {
  fileItems: Array<FileItem>;
}

interface Payload {
  market_rate_date: string;
  investor_code: string;
  files: any;
}

export function useSheetNameAction(market_rate_date: string, investor_code: string, files: any) {
  return useMutation({
    mutationFn: ({market_rate_date, investor_code}: Payload) =>
      executeSheetNameAction({market_rate_date: market_rate_date, investor_code: investor_code, files: files}),
      onSuccess: (response: any, payload) => {
      if (response.message) {
        toast(
          message(response.message),
        );
      } else {
        toast(
          message(`You has just executed check ${investor_code}.`),
        );
      }
      
      queryClient.invalidateQueries({queryKey: DatatableDataQueryKey(`market-rates/${market_rate_date}`)});
    },
    onError: err => showHttpErrorToast(err),
  });
}

function executeSheetNameAction({
  market_rate_date, investor_code, files
}: Payload): Promise<Response> {
  return apiClient
    .post(`market-rates/${market_rate_date}/execute-sheet-name-action`, FilePayloadToFormData({investor_code: investor_code, files: files}), {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then(r => r.data);
}

export function FilePayloadToFormData(
payload: Partial<Payload>,
) {
  const formData = new FormData();
  if (payload.investor_code) {
    formData.append("investor_code", payload.investor_code);
  }
  if (payload.files) {
      if (payload.files && payload.files.length > 0) {
        payload.files.forEach((file: any) => {
          formData.append("files[]", file);
        });
      }
  }

  return formData;
}

